"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHandleEmptyListTranslator = void 0;
exports.useHandleEmptyListTranslator = {
    en: {
        message: "Currently this list is empty...",
        buttonText: "ADD"
    },
    ru: {
        message: "Список пуст...",
        buttonText: "Добавить"
    }
};
